export const CollapseIcon = ({
    width = 16,
    height = 17,
    color = "#1D201E",
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 17"
        fill="none"
    >
        <rect
            width={width}
            height={height}
            transform="translate(0 0.5)"
            fill="white"
            fill-opacity="0.01"
        />
        <path d="M12 8H4V9H12V8Z" fill={color} />
    </svg>
);
